import React from "react";
import CouponBox from "./gifts-item";
import { useQuery } from '@apollo/client';
import doneIcon from "../../assets/images/doneIcon.png";
import arrowIcon from "../../assets/images/arrowNext.png";
import { GET_CAMPAIGNS_WITH_EXISITING_CODES_QUERY } from "queries/queries";
import { GET_MY_CAMPAIGNS_QUERY } from "queries/queries";
import Error from "../error";
import Loading from "../loading";
import { useHistory } from "react-router-dom";
import NoResultPage from "components/thankyou/noresult-page";
import useMakeScrollable from "custom_hooks/make-scrollable";
import backArrow from '../../assets/images/left_arrow.png';

const CouponsList = ({ }) => {
  useMakeScrollable();
  const { loading, error, data } = useQuery(GET_CAMPAIGNS_WITH_EXISITING_CODES_QUERY, {
    fetchPolicy: "no-cache",
  });

  const myCouponsResult = useQuery(GET_MY_CAMPAIGNS_QUERY, {
    fetchPolicy: "no-cache",
  });
  const history = useHistory();

  const handleBack = () => {
    history.goBack() 
  };

  if (loading || myCouponsResult.loading) return <Loading />;
  if (error || myCouponsResult.error) return <Error />;

  const couponType = data?.purchasableCampaigns.couponType || [];
  const instantType = data?.purchasableCampaigns.instantType || [];
  const myCoupons = myCouponsResult.data?.myCampaigns.couponType || [];
  const myInstant = myCouponsResult.data?.myCampaigns.instantType || [];

  if (!couponType.length && !instantType.length && !myCoupons.length && !myInstant.length) {
    return <NoResultPage text="Leider sind aktuell keine Coupons für Dich verfügbar." />
  }

  return (
    <div className="gifts scrollable">
      <div className="gifts-container">
        <img 
          src={backArrow} 
          alt="back" 
          className="points-header-arrow" 
          onClick={handleBack} 
        />
        {couponType.length > 0 && (
          <>
          <div>Verfügbare Coupons</div>
            {couponType.map((coupon) => (
              <CouponBox
                coupon={coupon}
                key={coupon.id}
                icon={arrowIcon}
                onClick={() => history.push(`/coupon/${coupon.id}`)}
              />
            ))}
          </>
        )}
        {instantType.length > 0 && (
          <>
          <div>Verfügbare Sofortaktionen</div>
            {instantType.map((coupon) => (
              <CouponBox
                coupon={coupon}
                key={coupon.id}
                icon={arrowIcon}
                onClick={() => history.push(`/coupon/${coupon.id}`)}
              />
            ))}
          </>
        )}
      </div>
      <div className="gifts-container">
        {myCoupons.length > 0 && (
          <>
            <div>Deine Coupons</div>
            {myCoupons.map((coupon) => (
              <CouponBox
                coupon={coupon}
                key={coupon.id}
                icon={doneIcon}
                onClick={() => {
                  history.push({
                    pathname: `/my-coupon/${coupon.id}`,
                    state: {
                      campaign: coupon,
                    }
                  });
                }}
              />
            ))}
          </>
        )}
      </div>
      <div className="gifts-container">
        {myInstant.length > 0 && (
          <>
            <div>Deine Sofortaktionen</div>
            {myInstant.map((coupon) => (
              <CouponBox
                coupon={coupon}
                key={coupon.id}
                icon={doneIcon}
                onClick={() => {
                  history.push({
                    pathname: `/my-coupon/${coupon.id}`,
                    state: {
                      campaign: coupon,
                    }
                  });
                }}
              />
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export default CouponsList;
